import React from 'react';

import TitleBarWrapper from '../../../shared/titleBarWrapper'
import FirstTitle from '../../../shared/items/static/firstTitle'

const REPORTS_BAR_TITLE = "Отчёты"

const ReportsTitleBar = () => {
  return (
    <TitleBarWrapper>
      <FirstTitle>
        {REPORTS_BAR_TITLE}
      </FirstTitle>
    </TitleBarWrapper>
  )
}

export default React.memo(ReportsTitleBar)
